<script setup lang="ts">
/**
 * Singbac — Nominee Director Service & Indemnity Agreement (company + resident director).
 * "Singbac" 은 리터럴 텍스트(변수 아님).
 */
import CddVarField from './cdd/CddVarField.vue';
import './allotDoc.css';
</script>

<template>
  <div class="allot-doc">
    <div class="doc-sec-title">NOMINEE DIRECTOR SERVICE &amp; INDEMNITY AGREEMENT</div>

    <p class="doc-p">THIS AGREEMENT is dated <CddVarField field-key="agreement_date" label="Agreement Date" /></p>

    <p class="doc-p">BETWEEN</p>

    <p class="doc-p">
      <CddVarField field-key="company_name" label="Company Name" /> (Company UEN No.:
      <CddVarField field-key="company_registration_no" label="Company Registration No." />), a company incorporated in
      Singapore, having its registered office at
      <CddVarField field-key="registered_office_address" label="Registered Office Address" /> (the "Company");
    </p>

    <p class="doc-p">and</p>

    <p class="doc-p">
      <CddVarField field-key="resident_director_name" label="Nominee Director Name" /> (NRIC No.:
      <CddVarField field-key="resident_director_nric" label="Nominee Director NRIC" />) c/o
      <CddVarField field-key="resident_director_address" label="Nominee Director Address" /> (the "Nominee Director");
    </p>

    <p class="doc-p">WHEREAS</p>

    <p class="doc-p">
      A. The Company has requested the Nominee Director to provide the services of a nominee who shall be appointed as a
      director of the Company, upon the terms and conditions as stated herein.
    </p>
    <p class="doc-p">B. The Nominee Director has agreed to be appointed as the aforesaid nominee.</p>

    <p class="doc-p">NOW IT IS HEREBY AGREED AS FOLLOWS:</p>

    <p class="doc-lbl-title">APPOINTMENT AND DUTIES</p>

    <p class="doc-p">
      1. The principal duties of the Nominee Director shall be the signing of statutory forms and board resolutions in
      order to comply with the requirements of Companies Act, 1967 and its regulations and the Company's Constitution,
      signing the bank application form for the purpose of opening a bank account and managing the CorpPass account of the
      Company (the "Principal Duties"). For the avoidance of doubt, the Nominee Director is not to be the sole signatory of
      the bank application form for the purpose of opening a bank account for the Company.
    </p>
    <p class="doc-p">
      2. For the avoidance of doubt, the Nominee Director shall not be required to participate, in any manner whatsoever,
      in the management or decision-making of the Company and shall not be required to sign or execute any agreement,
      assurance, guarantee or other documents which would incur or in any way impose any personal liability on the Nominee
      Director, whether as a principal or guarantor, notwithstanding that the same is purportedly for the benefit of the
      Company or any other third party. The Nominee Director shall also not be required to comply with any instructions
      which may be unlawful under the laws of Singapore as well as all other laws which may be applicable.
    </p>
    <p class="doc-p">
      3. In the event that the Nominee Director agrees to perform tasks in addition to the Principal Duties, the
      performance of such tasks shall be conditional on the Company's compliance with such conditions that the Nominee
      Director may require including but not limited to, the payment of additional fees, the provision of documents,
      reports and information and the engagement of competent independent professional advisers.
    </p>
    <p class="doc-p">
      4. In the event that the Company or its directors or shareholders ignore or refuse the requests made by the Nominee
      Director for documents that are reasonably required for the Nominee Director to perform their respective duties in
      accordance with the terms of this Agreement or as required under the laws of Singapore as well as all other laws
      which may be applicable, the Nominee Director shall be entitled to impose an administrative fee on the Company (the
      "Administrative Fee"). The quantum of the Administrative Fee shall be determined based on the additional time spent
      by the Nominee Director to obtain the documents reasonably required and expenses incurred by the Nominee Director in
      obtaining preliminary professional advice.
    </p>
    <p class="doc-p">
      5. No remedy conferred by any of the provisions of this Agreement is intended to be exclusive of any other remedy
      which is otherwise available at law, in equity, by statute or otherwise, and each and every other remedy shall be
      cumulative and shall be in addition to every other remedy given hereunder or now or hereafter existing at law, in
      equity, by statute or otherwise. The election of any one or more of such remedies by any Party shall not constitute
      a waiver by such Party of the right to pursue any other available remedies.
    </p>

    <p class="doc-lbl-title">TERMINATION</p>

    <p class="doc-p">
      6. Either the company or the Nominee Director may terminate this agreement at any time by providing the other party
      with one (1) months' notice in writing.
    </p>
    <p class="doc-p">
      7. In the event of the nominee director ceasing (for whatever reason) to provide the services of the Nominee
      Director, the board of directors of the Company shall accept the resignation of the Nominee Director and where
      required under the Companies Act, 1967 and its regulations or the Company's Constitution, shall take immediate steps
      to appoint another person in place of the Nominee Director as a director of the Company on or before the date of
      termination and/or cessation.
    </p>

    <p class="doc-lbl-title">INDEMNITY AND WARRANTY</p>

    <p class="doc-p">
      8. To the furthest extent permitted by law, the Company hereby irrevocably and unconditionally, undertakes to
      indemnify and keep indemnified:-
    </p>
    <p class="doc-p indent">
      the Nominee Director at all times, and save him harmless from and against all costs (including without limitation
      legal costs), charges, damages, liabilities, penalties, demands, expenses, actions, suits, proceedings and claims of
      whatever nature and however arising if incurred, suffered or sustained by him, to a person other than the Company,
      as a result of or in connection with the appointment of the Nominee Director pursuant to the Agreement, or in the
      course of the Nominee Director carrying out his duties pursuant to the Agreement or as a director of the Company.
    </p>

    <p class="doc-lbl-title">WARRANTIES AND COVENANTS</p>

    <p class="doc-p">9. The Company hereby undertakes and warrants to the Nominee Director that:-</p>
    <p class="doc-p indent">
      (a) throughout the course of his appointment as nominee director, the Nominee Director shall not be the sole
      director of the Company. The Company shall take all steps to appoint another person as an additional director of the
      Company during the course of this Agreement;
    </p>
    <p class="doc-p indent">
      (b) all acts required to be done by the Nominee Director shall be lawful under the laws of Singapore as well as all
      other laws which may applicable and that all statements and documents, which the Nominee Director is requested to
      sign, shall be true and accurate;
    </p>
    <p class="doc-p indent">
      (c) the Company will keep proper accounts and will file all income tax returns and all papers and documents which
      are required by law to be filed with any authority and that all taxes required to be paid by the Company will be
      duly paid;
    </p>
    <p class="doc-p indent">
      (d) the Company will provide the Nominee Director with all documents, reports and information including but not
      limited to bank statements and financial reports that are reasonably required for the Nominee Director to perform
      their respective duties in accordance with the terms of this Agreement or as required under the laws of Singapore as
      well as all other laws which may be applicable;
    </p>
    <p class="doc-p indent">
      (e) the Company will engage and bear all related fees, costs and expenses of competent independent professional
      advisers that that are reasonably required for the Nominee Director to perform their respective duties in accordance
      with the terms of this Agreement or as required under the laws of Singapore as well as all other laws which may be
      applicable,
    </p>
    <p class="doc-p indent">
      (f) the Company authorises the Nominee Director to receive, open and monitor any of the Company's postal mail
      addressed to the registered office address of the company.
    </p>
    <p class="doc-p indent">
      (g) the Company irrevocably and unconditionally consents to the Nominee Director disclosing any information made
      available to the Nominee Director in his capacity as a director of the Company to the appointed corporate
      secretarial provider and will procure that the board of directors shall pass all necessary resolutions to give
      effect to this provision.
    </p>

    <p class="doc-lbl-title">GENERAL</p>

    <p class="doc-p">
      10. In the event that any provision is held to be in violation of any applicable laws, statutes or regulations or
      unenforceable in whole or in part, such part or parts as are invalid, illegal or unenforceable shall be deleted from
      this Agreement and shall be of no force and effect and any such deletion shall not affect the validity, legality and
      enforceability of all such part or parts of this Agreement that remain and not so deleted.
    </p>
    <p class="doc-p">
      11. At any time after the date of this Agreement, each Party shall, and shall use its best endeavours to procure
      that any necessary third party shall, execute such documents and do such further acts, deeds, things and documents
      as may be necessary to give effect to the terms of this Agreement.
    </p>
    <p class="doc-p">
      12. This Agreement and the documents referred to herein are in substitution for all previous agreements between all
      or any of the Parties and contain the whole agreement between the Parties relating to the subject matter of this
      Agreement.
    </p>
    <p class="doc-p">
      13. Any date, time or period mentioned in any provision of this Agreement may be extended by mutual agreement
      between the parties but as regards any time, date or period originally fixed and not extended or any time, date or
      period so extended as aforesaid
    </p>
    <p class="doc-p">
      14. Subject as otherwise provided herein, all notices, demands or other communications required or permitted to be
      given or made hereunder shall be in writing and delivered personally or sent by prepaid registered post or
      certificate of posting or electronic mail addressed to the intended recipient thereof at its address or its
      electronic mail address set out herein (or to such other address or electronic mail address as any Party may from
      time to time notify the other Parties for the purpose of this clause) or by other means which parties may agree in
      writing thereafter. Any notice, demand or communication shall be deemed to have been duly served:
    </p>
    <p class="doc-p indent">(a) if delivered personally, on the day of delivery;</p>
    <p class="doc-p indent">
      (b) if sent by letter to a local address, forty-eight (48) hours after posting and in proving the same it shall be
      sufficient to show that the envelope containing the notice, demand or communication was duly addressed, stamped and
      posted;
    </p>
    <p class="doc-p indent">
      (c) if sent by letter to an overseas address, ten (10) days after posting and in proving the same it shall be
      sufficient to show that the envelope containing the notice, demand or communication was duly addressed, stamped and
      posted; and
    </p>
    <p class="doc-p indent">
      (d) if sent by electronic mail, when the relevant receipt of such communication being read is given, or where no
      read receipt is requested by the sender, at the time of sending, provided that no delivery failure notification is
      received by the sender within twenty-four (24) hours of sending such communication.
    </p>
    <p class="doc-p">
      15. This Agreement shall be binding upon and enure for the benefit of the successors-in-title and permitted
      assignees of the parties. Neither Party shall (nor shall it purport to) assign, transfer, charge or otherwise deal
      with all or any of its rights under this Agreement nor grant, declare or dispose of any right or interest in it
      without the prior written consent of the other Party.
    </p>
    <p class="doc-p">
      16. No variation of this Agreement (or any of the documents referred to in this Agreement) shall be valid unless it
      is in writing and signed by or on behalf of each Party. The expression "variation" shall include any amendment,
      supplement, deletion or replacement however effected. Unless expressly agreed, no variation shall constitute a
      general waiver of any provisions of this Agreement, nor shall it affect any rights, obligations or liabilities under
      or pursuant to this Agreement which have already accrued up to the date of variation, and the rights and obligations
      of the Parties under or pursuant to this Agreement shall remain in full force and effect, except and only to the
      extent that they are so varied.
    </p>
    <p class="doc-p">
      17. All costs and expenses incurred in the preparation and negotiation of this Agreement shall be at the expense of
      the Company.
    </p>
    <p class="doc-p">
      18. No failure on the part of any Party to exercise, and no delay on its part in exercising, any right or remedy
      under this Agreement will operate as a waiver thereof, nor will any single or partial exercise of any right or
      remedy preclude any other or further exercise thereof or the exercise of any other right or remedy. The rights
      provided in this Agreement are cumulative and not exclusive of any rights or remedies provided by law.
    </p>
    <p class="doc-p">
      19. A person who is not party to this Agreement has no rights under the Contracts (Rights of Third Parties) Act -
      Chapter 53B of Singapore to enforce any term of this Agreement.
    </p>
    <p class="doc-p">
      20. The representations, covenants, warranties and undertakings herein shall continue to have full force and effect
      notwithstanding the cessation (for whatever reason) of the services of the Nominee Director.
    </p>
    <p class="doc-p">
      21. This Agreement may be executed in two or more counterparts, and this has the same effect as if the signatures on
      the counterparts were on a single copy of this Agreement. Each counterpart may be signed and executed by the parties
      and transmitted by electronic mail, and shall be as valid and effectual as if executed as an original. For the
      avoidance of doubt, in the case of execution by way of counterparts, this Agreement shall not be deemed to be
      concluded until the last of such counterparts shall have been executed.
    </p>
    <p class="doc-p">
      22. Any reference to a statutory provision shall include such provision and any regulations made in pursuance
      thereof as from time to time modified or re-enacted whether before or after the date of this Agreement.
    </p>
    <p class="doc-p">
      23. This Agreement shall be governed by and construed in accordance with the laws of the Republic of Singapore and
      parties agree to submit to the non-exclusive jurisdiction of the courts of the Republic of Singapore.
    </p>

    <p class="doc-p">IN WITNESS whereof the parties have duly executed this Agreement as of the date and year written above.</p>

    <div class="sig-block">
      <p class="doc-p"><CddVarField field-key="client_name" label="Client Name" /></p>
      <p class="doc-p"><CddVarField field-key="company_name" label="Company Name" /></p>
      <div class="sig-line">________________________________________</div>
      <div class="sig-cap">Signature</div>
      <div class="sig-cap">Name</div>
    </div>

    <div class="sig-block">
      <p class="doc-p"><CddVarField field-key="resident_director_name" label="Nominee Director Name" /></p>
      <div class="sig-line">________________________________________</div>
      <div class="sig-cap">Signature</div>
    </div>
  </div>
</template>

<style scoped>
.doc-lbl-title { font-weight: 800; margin: 14px 0 6px; }
.sig-block { margin-top: 26px; }
.sig-line { font-family: monospace; margin-top: 18px; }
.sig-cap { font-size: 11px; color: #444; margin-top: 2px; }
</style>
